import PropTypes from 'prop-types';
import ToolTipStyles from './ToolTipStyles'
import { ReactSVG } from 'react-svg'

const InlineToolTip = ToolTipStyles.withComponent('span');
const ToolTip = ({ text, styleText, background = '#1dab90', inline = false, svg = false, inlineIcon = 'i', customSvg = false, hoverText=false }) => {

    if (customSvg && hoverText) {
        return (<InlineToolTip>
            <span>{hoverText}</span>
            <ReactSVG src={customSvg} className="icon" />
            <span className={'tooltip-text ' + (styleText || "")}>{text}</span>
        </InlineToolTip>
        )
    }

    if (customSvg) {
        return (<InlineToolTip>
            <ReactSVG src={customSvg} className="icon" />
            <span className={'tooltip-text ' + (styleText || "")}>{text}</span>
        </InlineToolTip>
        )
    }

    if (inline) {
        return (<InlineToolTip background={background}>{inlineIcon}
            <span className={'tooltip-text ' + (styleText || "")}>{text}</span>
        </InlineToolTip>
        )
    }

    if (svg) {
        return (<InlineToolTip>
            <ReactSVG src="/static/images/icons/tooltip-icon.svg?type=svg" className="icon" />
            <span className={'tooltip-text ' + (styleText || "")}>{text}</span>
        </InlineToolTip>
        )
    }

    return (<ToolTipStyles background={background}>i
        <span className={'tooltip-text ' + (styleText || "")}>{text}</span>
    </ToolTipStyles>)
};

ToolTip.propTypes = {
    text: PropTypes.string,
    styleText: PropTypes.string,
    background: PropTypes.string
};

export default ToolTip;
